export const GMAPS_API_KEY = process.env.REACT_APP_GMAPS_API_KEY || "AIzaSyAOyNvYDzqdx0gAwVovKwsFchhksM2HRWQ";
export const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY || "pk_test_K2qzkRGKvDfyIDq28aRuJtjp00i9QOz6l7";
export const BANKART_API_KEY = process.env.REACT_APP_BANKART_API_KEY || "izkwxrFBsZrkuPALWU5w";
export const CAPTCHA_SITE_KEY = process.env.REACT_APP_CAPTCHA_SITE_KEY || "6LffC0AqAAAAANUDnjhGcBHmKdr9xIaFFQl-axgs";

// Feature flags
export const ALLOW_DIFFERENT_BILLING_ADDRESS = false;  // Allow selecting "druga oseba" for card payment billing